import { render, staticRenderFns } from "./pc-loader.vue?vue&type=template&id=5fbff826&"
import script from "./pc-loader.vue?vue&type=script&lang=js&"
export * from "./pc-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports